<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="tableActions"
    :list="list"
    v-on="$listeners || {}"
  >
    <template #item.counts="{ data }">
      <nobr>Регионов: {{ data.region_count }}</nobr>
      <br>
      <nobr>Муниципалитетов: {{ data.municipality_count }}</nobr>
      <br>
      <nobr>ОО: {{ data.school_count }}</nobr>
    </template>
  </BTable>
</template>

<script>
import {
  TABLE_ACTIONS,
  TABLE_ACTIONS_ADMIN,
  TABLE_HEADERS,
} from '@/views/Participants/table-headers'
import BTable from '@/components/common/BTable.vue'
import { rootMapper } from '@/store/modules/root'


export default {
  name: 'BTableParticipants',
  components: {
    BTable,
  },
  inheritAttrs: false,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
    },
    list: {
      type: Array,
    },
  },
  computed: {
    ...rootMapper.mapGetters(['profile']),
    tableActions() {
      if (this.actions) return this.actions
      return this.profile.is_admin ? TABLE_ACTIONS_ADMIN : TABLE_ACTIONS
    },
  },
}
</script>
